import { FC, Fragment } from "react";

export type DescriptionItemTittleProps = {
  text: string;
};

export const DescriptionItemTittleCart: FC<DescriptionItemTittleProps> = ({
  text,
}) => {
  return (
    <Fragment>
      <dt className="text-sm">{text}</dt>
    </Fragment>
  );
};
